import {css, styled} from '@mui/material/styles';
import clsx from 'clsx';
import {forwardRef} from 'react';
import {StackedNavList} from '../base/StackedNavList';
import {navCssClassNames} from '../navCssClassNames';
import {NavItem} from '../NavItem';
import {NavItemButton} from '../NavItemButton';
import {NavItemCollapse} from '../NavItemCollapse';
import {SharedNavProps} from './types';

export type FixedSideNavProps = SharedNavProps;

const navMinWidth = '15rem'; // arbitrary
const navMaxWidth = '19.25rem'; // figma spec

const StyledNav = styled('nav')(({theme}) => css`
    grid-area: fixed-side-nav;

    background-color: ${theme.tokens.FuelColorWhite};
    min-width: ${navMinWidth};
    max-width: ${navMaxWidth};
    width: auto;
    height: 100%;
    border-right: solid 1px ${theme.tokens.FuelColorBorderBase};
`);

export const FixedSideNav = forwardRef<HTMLElement, FixedSideNavProps>(({
    children, className, items, ...props
}, ref) => (
    <StyledNav
        className={clsx(navCssClassNames.variantFixedSide, 'FixedSideNav-root', className)}
        ref={ref}
        {...props}
    >
        <StackedNavList className={navCssClassNames.list}>
            {children ?? items?.map(({
                label, subNavigationItems, ...itemProps
            }, itemIndex) => (
                <NavItem key={itemIndex}>
                    {subNavigationItems?.length ? (
                        <NavItemCollapse
                            {...itemProps}
                            items={subNavigationItems}
                        >
                            {label}
                        </NavItemCollapse>
                    ) : (
                        <NavItemButton
                            {...itemProps}
                            orientation='side'
                        >
                            {label}
                        </NavItemButton>
                    )}
                </NavItem>
            ))}
        </StackedNavList>
    </StyledNav>
));

FixedSideNav.displayName = 'FixedSideNav';
